import { Flex, Tag } from 'antd';
import { useCallback, useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const RecordsCountSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeRecordsCountRange } = useNewClientsListContext();

  const { recordsCountRange } = filtersMap.get(id)!;

  const values = useMemo(() => {
    const { from, to } = recordsCountRange;

    return [
      { value: from, label: `от ${from}` },
      { value: to, label: `до ${to}` },
    ].filter(({ value }) => value !== null);
  }, [recordsCountRange]);

  const onDelete = useCallback(
    (value: number | null) => {
      if (value === recordsCountRange.from) {
        onChangeRecordsCountRange({ from: null, to: recordsCountRange.to }, id);
      } else if (value === recordsCountRange.to) {
        onChangeRecordsCountRange(
          { from: recordsCountRange.from, to: null },
          id
        );
      }
    },
    [recordsCountRange, onChangeRecordsCountRange, id]
  );

  if (values.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {values.map(({ value, label }) => (
        <Tag
          key={value}
          className={`${PF}__tag`}
          closable
          onClose={() => onDelete(value)}
        >
          {label}
        </Tag>
      ))}
    </Flex>
  );
};
